<template>
  <v-card
    class="mx-auto"
    max-width="433"
  >
      <v-card-title>
        Παρακαλώ εισάγετε τα στοιχεία σας
      </v-card-title>

    <v-card-text>
      <v-text-field
        v-model="credentials.username"
        label="Όνομα Χρήστη"
      ></v-text-field>

      <v-text-field
        v-model="credentials.password"
        label="Κωδικός"
        type="password"
      ></v-text-field>
    </v-card-text>

    <p class="font-weight-regular" style="color: red;">
      {{ error }}
    </p>

    <v-card-actions>
          <v-btn
            @click="login"
            :loading="loading"
          >ΕΙΣΟΔΟΣ</v-btn>
    </v-card-actions>

  </v-card>
</template>

<script>

export default {
  name: 'Login',
  data: () => {
    return {
      credentials: {
        username: "",
        password: ""
      },
      error: "",
      loading: true
    }
  },
  async mounted() {
    const result = await this.$store.dispatch('user/tryExistingJwt')
    
    if (result) {
      this.loading = false
      this.routerNext()
      return
    }

    this.loading = false
  },
  methods: {
    routerNext() {
      const params = this.$route.params
      if (!params.redirectTo || params.redirectTo === '/' || params.redirectTo === ''){
        this.$router.replace('/dashboard')
      }

      this.$router.replace(params.redirectTo)
    },
    async login() {
      const payload = {
        username: this.credentials.username,
        password: this.credentials.password
      }

      this.error = ""
      this.loading = true
      
      const err = await this.$store.dispatch('user/login', payload)
      
      if (err == null) {
        this.loading = false
        this.routerNext()
        return
      }

      this.loading = false
      this.error = err
    }
  }
}
</script>
